export const raribleMintAndTransferFunction = "0x0eaead67";
export const raribleSafeTransferFunction = "0xf242432a";
export const raribleBurnFunction = "0xf5298aca";
